import { ElementType, LayoutElement } from '../../../types/models/Elements';
import { panoramicLayouts2Photos } from '../panoramic/2photos';

export const mugLayouts2Photos: LayoutElement[][] = [
  ...panoramicLayouts2Photos,
];
